import { Download } from "lucide-react";
import { KIT_PREVIEW, KIT_URL } from "@/lib/api";

const SPECS = ["PNG, transparent background", "4500 x 5400 px · 300 dpi (15 x 18 in)", "Max 6 colours recommended", "Lines at least 1 pt thick", "Keep text inside the safe area"];

export const DesignerKitLink = ({ className = "", testid = "designer-kit-link" }) => (
  <a href={KIT_URL} className={`link-u inline-flex items-center gap-2 ${className}`} data-testid={testid}><Download size={14} /> Sus Designer Kit</a>
);

export const DesignerKit = () => (
  <section className="my-12 grid items-center gap-8 overflow-hidden rounded-[24px] border-[1.5px] border-ink bg-sky md:grid-cols-[260px_1fr]" aria-labelledby="kit-title" data-testid="designer-kit-section">
    <img src={KIT_PREVIEW} alt="Tee print-area template with bleed, safe area and centre line" className="h-full w-full bg-cloud object-contain p-4" loading="lazy" />
    <div className="p-6 md:pl-0">
      <p className="label font-bold">Free download</p>
      <h2 id="kit-title" className="display mt-2 text-5xl">Sus Designer Kit</h2>
      <p className="font-a mt-3 text-[15px]">Tee templates (front + back PNG, SVG outlines), a how-to-submit sheet and our brand guide.</p>
      <ul className="mt-4 grid gap-1 font-mono text-xs sm:grid-cols-2">{SPECS.map((s) => <li key={s}>· {s}</li>)}</ul>
      <a href={KIT_URL} className="btn btn-ink mt-6" data-testid="designer-kit-download"><Download size={15} /> Download the kit (ZIP)</a>
    </div>
  </section>
);
